import { createApi } from "@reduxjs/toolkit/query/react";
import { createCustomFetchBaseQuery } from "../baseQuery";

export const supportCenterCategoryApi = createApi({
    reducerPath: "supportCenterCategoryApi",
    baseQuery: createCustomFetchBaseQuery(),
    tagTypes: ["SupportCenterCategory"],
    endpoints: (builder) => ({
        getAllSupportCenterCategories: builder.query({
            query: ({ pageno, search ,sortOrder, sortBy, limit}) => {
                let url = `/admin/support-center-categories?pageno=${pageno}`;
                if (search) {
                    url += `&search=${search}`;
                }
                if (sortOrder && sortBy) {
                    url += `&sortOrder=${sortOrder}&sortBy=${sortBy}`;
                }
                if (limit) {
                    url += `&limit=${limit}`;
                }
                return {
                    url,
                    method: "GET",
                }
            },
            providesTags: ["SupportCenterCategory"],
        }),
        addSupportCenterCategory: builder.mutation({
            query: (data) => ({
                url: `/admin/support-center-category`,
                method: "POST",
                body: data,
            }),
            invalidatesTags: ["SupportCenterCategory"],
        }),
        updateSupportCenterCategory: builder.mutation({
            query: ({ id, data }) => ({
                url: `/admin/support-center-category/${id}`,
                method: "PUT",
                body: data,
            }),
            invalidatesTags: ["SupportCenterCategory"],
        }),
        deleteSupportCenterCategory: builder.mutation({
            query: (id) => ({
                url: `/admin/support-center-category/${id}`,
                method: "DELETE",
            }),
            invalidatesTags: ["SupportCenterCategory"],
        }),
        getActiveSupportCenterCategories: builder.query({
            query: () => {
                let url = `/admin/support-center-categories/active`;
                return {
                    url,
                    method: "GET",
                }
            },
            providesTags: ["SupportCenterCategory"],
        }),
        getUserSupportCenterCategories: builder.query({
            query: () => {
                let url = `/contractor/resource/categories`;
                return {
                    url,
                    method: "GET",
                }
            },
        }),
    }),
});

export const {
    useGetAllSupportCenterCategoriesQuery,
    useAddSupportCenterCategoryMutation,
    useUpdateSupportCenterCategoryMutation,
    useDeleteSupportCenterCategoryMutation,
    useGetActiveSupportCenterCategoriesQuery,
    useGetUserSupportCenterCategoriesQuery,
} = supportCenterCategoryApi;
